import Swiper from "swiper";

function setupSwiper(swiperDiv) {
  if (!swiperDiv) return;
  new Swiper(swiperDiv, {
    autoplay: {
      delay: 14000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
    },
  });
}

export default setupSwiper;



// WEBPACK FOOTER //
// ./public/javascripts/modules/swiper.js